enum NylasObjectType {
  free_busy
  time_slot
}

type NylasFreeBusyObject {
  object: NylasObjectType
  email: String!
  time_slots: [NylasTimeSlot!]!
}

type NylasTimeSlot {
  end_time: Int!
  start_time: Int!
  status: String
  object: NylasObjectType
}

type NylasWhen {
  start_time: String!
  end_time: String!
}

type NylasEvent {
  id: ID!
  account_id: ID
  busy: Boolean
  calendar_id: ID
  title: String!
  participants: [NylasEventParticipant!]!
  when: NylasWhen!
}

type NylasEventParticipant {
  email: String
  name: String
}

input NylasEventParticipantInput {
  email: String
  name: String
}

input NylasEventWhenInput {
  end_time: Int
  end_timezone: String
  start_time: Int
  start_timezone: String
}

input NylasEventInput {
  title: String!
  busy: Boolean!
  participants: [NylasEventParticipantInput!]!
  when: NylasEventWhenInput!
  owner_user_id: ID
}
